export const voucherIssueTypes = {
  afterEachClassForFirstTrial: {
    value: 1,
    name: '新学员每次试课签到完成后自动发放',
  },
  manualProcessing: {
    value: 2,
    name: '手动办理',
  },
  activity: {
    value: 3,
    name: '活动发放',
  },
  afterPurchaseCardTicket: {
    value: 4,
    name: '购买课次券后发放',
  },
  appPurchase: {
    value: 5,
    name: '小程序购买',
  },
};

export function findVoucherIssueType(value) {
  for (const key in voucherIssueTypes) {
    if (value === voucherIssueTypes[key].value) return [voucherIssueTypes[key]];
  }
  return [{}];
}
